import { KeyboardArrowLeft, KeyboardArrowRight, Warning } from '@mui/icons-material';
import { Button, MobileStepper, Typography } from '@mui/material';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Stepper from '@mui/material/Stepper';
import Box from '@mui/system/Box';
import { FC, useState } from 'react';
import 'react-notifications/lib/notifications.css';
import { isStepNotComplete } from '../../common/utils';
import { PersonalTabs, UserProfileParts, UserProfileStep } from '../../consts/types/user';
import Experience from './Experience';
import PersonalDetails from './PersonalDetails';
import Personality from './Personality';
import Recommendations from './Recommendations';
import Skills from './Skills';
import Social from './Social';


interface UserProps {

}

type Props = UserProps;


const User: FC<Props> = (props: Props) => {
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = UserProfileParts.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step: number) => () => {
        setActiveStep(step);
    };


    return <Box height="100%">

        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box display="flex" flex={1} gap={3} justifyContent={{ xs: "center", md: "flex-start" }}>
                <Box sx={{ display: { xs: "none", md: "flex" }, background: "#f7fbff", borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px" }} alignItems="baseline" py={3} px={2.5}>
                    <Stepper nonLinear orientation='vertical' activeStep={activeStep} >
                        {UserProfileParts.map((step, index) => (
                            <Step key={step.label}>
                                <StepButton optional={isStepNotComplete(step.label) && <Box display="flex" alignItems="center" color="#efb17e">
                                    <Warning fontSize='inherit' sx={{ mr: 1 }} />
                                    Not completed yet
                                </Box>}
                                    color="inherit" onClick={handleStep(index)} sx={{ whiteSpace: "nowrap" }}>
                                    {step.label}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>

                </Box>
                <Box px={3} py={{ xs: 2, md: 3 }} width="100%" maxHeight={{ xs: "initial", md: "calc(100vh - 220px)" }} minHeight={{ xs: "initial", md: "calc(100vh - 220px)" }} overflow="auto" display="flex" flexDirection="column">
                    <Typography fontSize={{ xs: "1.1rem", md: "1.5rem" }} mb={3}>{UserProfileParts[activeStep].label}</Typography>
                    {UserProfileParts[activeStep].label === UserProfileStep.PersonalDetails && <PersonalDetails currentTab={PersonalTabs.Personal} onClose={() => { }} />}
                    {UserProfileParts[activeStep].label === UserProfileStep.EducationAndExperience && <Experience />}
                    {UserProfileParts[activeStep].label === UserProfileStep.SkillsTest && <Skills />}
                    {UserProfileParts[activeStep].label === UserProfileStep.Recommenders && <Recommendations />}
                    {UserProfileParts[activeStep].label === UserProfileStep.SocialAccounts && <Social />}
                    {UserProfileParts[activeStep].label === UserProfileStep.PersonalityQuiz && <Personality />}
                </Box>
            </Box>
            <MobileStepper
                sx={{ display: { xs: "flex", md: "none" }, }}
                variant="text"
                steps={maxSteps}
                position="bottom"
                activeStep={activeStep}
                nextButton={
                    <Button
                        size="small"
                        onClick={handleNext}
                        disabled={activeStep === maxSteps - 1}
                    >
                        Next
                        <KeyboardArrowRight />
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        <KeyboardArrowLeft />
                        Back
                    </Button>
                }
            />
        </Box>

    </Box>;
}


export default User;

